import { SVGProps, Ref, forwardRef } from 'react';

export const GESize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <rect y={3} width={24} height={18} rx={3} fill="#EEEEEE" />
            <path d="M10.125 13.875V21h3.75v-7.125H24v-3.75H13.875V3h-3.75v7.125H0v3.75z" fill="#E8112D" />
            <path
                d="M5.743 17.743q.035.695.164 1.382a5.3 5.3 0 0 0-1.314 0q.128-.687.164-1.382-.695.035-1.382.164a5.3 5.3 0 0 0 0-1.314q.687.13 1.382.164a10 10 0 0 0-.164-1.382c.436.054.878.054 1.314 0q-.128.687-.164 1.382.695-.035 1.382-.164a5.3 5.3 0 0 0 0 1.314 10 10 0 0 0-1.382-.164"
                fill="#E8112D"
            />
            <path
                d="M19.407 19.125a10 10 0 0 1-.164-1.382q.695.034 1.382.164a5.3 5.3 0 0 1 0-1.314q-.687.13-1.382.164.035-.695.164-1.382a5.3 5.3 0 0 1-1.314 0q.13.687.164 1.382a10 10 0 0 1-1.382-.164c.054.436.054.878 0 1.314q.687-.13 1.382-.164-.035.695-.164 1.382a5.3 5.3 0 0 1 1.314 0"
                fill="#E8112D"
            />
            <path
                d="M5.743 7.243q.035.695.164 1.382a5.3 5.3 0 0 0-1.314 0q.128-.687.164-1.382-.695.035-1.382.164a5.3 5.3 0 0 0 0-1.314q.687.128 1.382.164a10 10 0 0 0-.164-1.382c.436.054.878.054 1.314 0q-.128.687-.164 1.382.695-.035 1.382-.164a5.3 5.3 0 0 0 0 1.314 10 10 0 0 0-1.382-.164"
                fill="#E8112D"
            />
            <path
                d="M19.407 8.625a10 10 0 0 1-.164-1.382 10 10 0 0 1 1.382.164 5.3 5.3 0 0 1 0-1.314q-.687.128-1.382.164.035-.695.164-1.382a5.3 5.3 0 0 1-1.314 0q.13.687.164 1.382a10 10 0 0 1-1.382-.164c.054.436.054.878 0 1.314q.687-.128 1.382-.164-.035.696-.164 1.382a5.3 5.3 0 0 1 1.314 0"
                fill="#E8112D"
            />
        </g>
    </svg>
));
GESize24Glyph.displayName = 'GESize24Glyph';
